<div ng-if="!$ctrl.item" class="list-item empty" ng-style="{ height: $ctrl.itemHeight }"></div>
<div ng-if="$ctrl.item && !$ctrl.item.loaded" class="list-item loading" ng-style="{ height: $ctrl.itemHeight }">
    <div class="spinner-padding">
        <i class="fa fa-circle-o-notch fa-spin fa-fw"></i>
    </div>
</div>
<div ng-if="$ctrl.item && $ctrl.item.loaded && !$ctrl.item.endOfList" class="content-wrapper list-item loaded" ng-class="$ctrl.activeClassNames()" ng-style="{ 'min-height': $ctrl.itemHeight }" ng-click="$ctrl.itemClick($event)">
    <div ng-if="$ctrl.item.indicatorColor" class="indicator" ng-class="$ctrl.item.indicatorColor"></div>
    <div ng-if="$ctrl.options.showCheckboxes" class="checkbox" ng-click="$ctrl.clickPassthru($event)">
        <c-checkbox checked="$ctrl.checkedBox()" enabled="$ctrl.enabledBox()"></c-checkbox>
    </div>
    <div class="container" style="z-index:1">
        <c-list-item-container item-template="$ctrl.itemTemplate" list-item="$ctrl.item" highlight="$ctrl.highlight"></c-list-item-container>
    </div>
</div>